import React from 'react';
import { Link } from 'react-router-dom';
import { Home, AlertCircle } from 'lucide-react';

export function NotFoundPage() {
  // Set document title
  React.useEffect(() => {
    document.title = '404 - Page Not Found | Recberry';
  }, []);

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
      padding: '2rem'
    }}>
      <div style={{
        backgroundColor: 'white',
        borderRadius: '16px',
        padding: '3rem',
        maxWidth: '600px',
        width: '100%',
        textAlign: 'center',
        boxShadow: '0 10px 40px rgba(0, 0, 0, 0.1)'
      }}>
        <div style={{
          width: '80px',
          height: '80px',
          backgroundColor: '#fee2e2',
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          margin: '0 auto 2rem',
        }}>
          <AlertCircle size={40} style={{ color: '#dc2626' }} />
        </div>
        
        <h1 style={{
          fontSize: '3rem',
          fontWeight: '700',
          color: 'var(--dark)',
          marginBottom: '1rem',
          fontFamily: 'var(--montserrat)'
        }}>
          404
        </h1>
        
        <h2 style={{
          fontSize: '1.5rem',
          fontWeight: '600',
          color: 'var(--dark)',
          marginBottom: '1rem',
          fontFamily: 'var(--montserrat)'
        }}>
          Page Not Found
        </h2>
        
        <p style={{
          fontSize: '1rem',
          color: 'var(--gray)',
          marginBottom: '2rem',
          lineHeight: '1.6',
          fontFamily: 'var(--raleway)'
        }}>
          The page you're looking for doesn't exist or has been moved.
        </p>
        
        <Link
          to="/"
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '0.5rem',
            background: 'var(--orange)',
            color: 'var(--dark)',
            padding: '0.875rem 2rem',
            borderRadius: '8px',
            textDecoration: 'none',
            fontWeight: '600',
            fontFamily: 'var(--montserrat)',
            transition: 'all 0.2s ease'
          }}
          onMouseOver={(e) => {
            e.currentTarget.style.background = '#d4a017';
            e.currentTarget.style.transform = 'translateY(-2px)';
          }}
          onMouseOut={(e) => {
            e.currentTarget.style.background = 'var(--orange)';
            e.currentTarget.style.transform = 'translateY(0)';
          }}
        >
          <Home size={20} />
          Go to Homepage
        </Link>
      </div>
    </div>
  );
}
